var productCardMarkup = 
  `<ul class="swym-wishlist-grid grid grid-cols-2 lg:grid-cols-4 gap-2 lg:gap-6 list-none p-0">
		{{#products}} 
		<li class="collection-item js-collection-item collection-item-he collection-item-he--1 pb-6"><div class="text-center relative">
		<button onclick="onRemoveBtnClick(event)" aria-label="Remove from wishlist" data-variant-id="{{epi}}" data-product-id="{{empi}}" class="swym-remove-x-btn swym-is-button absolute top-0 right-0 p-2 sm:p-2 z-10 transition-opacity duration-300 hover:opacity-60" style="right:2px; z-index:9;">
			<svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round">
				<line x1="2" y1="2" x2="14" y2="14"/><line x1="14" y1="2" x2="2" y2="14"/>
			</svg>
		</button>

	<a href="{{du}}" aria-label="{{dt}}" class="{{^isAvailable}}collection-item-so {{/isAvailable}}">
		<div class="swym-wishlist-image-wrapper aspect-h-4 aspect-w-3 block transition-opacity duration-300 hover:opacity-50 mb-4 sm:mb-8">
		<img alt="" class="swym-wishlist-image" src="{{iu}}">
		{{^isAvailable}}        
       <div class="sold-out-button collection-item-so-label pointer top_padding">SOLD OUT</div>
       {{/isAvailable}}
		</div>
       
         <button class="swym-is-button" style="width:100%">
         <div class="grid-view-item__vendor text-sm sm:text-base font-medium uppercase tracking-widest mb-3 sm:mb-4" id="swym-vendor-title">{{vendor}}</div>  
		<div class="grid-view-item__title swym-title text-xs sm:text-sm max-w-xs mb-0 mx-auto h-12 sm:h-16 line-clamp-3">
			{{dt}}
		</div>
  </button>
        <div class = "height-desktop" style = "min-height: 39px; {{^compare_at_price }} margin-bottom: 1.6rem; {{/compare_at_price }}   ">
        {{#erpp}}
		<p class="text-2xs mb-3 border-black/20 border w-auto inline-block mx-auto uppercase tracking-widest font-semibold py-1 px-4">
        <span id="swym-erpp-value">Est. retail {{cu}}{{erpp}}</span>
		</p>
        {{/erpp}}
	</div>
 <span style="text-decoration: line-through;"><span class="money swym-product-final-price swym-value text-sm {{^compare_at_price }} hidden{{/compare_at_price}}" data-currency-gbp  >£{{compare_at_price}}</span></span>
		<div class="text-lg sm:text-xl font-serif collection-item__price text-upper swym-product-price swym-text swym-text-1 mb-4">
			<div class="swym-product-final-price swym-value" style = "{{#compare_at_price }} color: #FF3C3C; {{/compare_at_price}}">
				{{cu}}{{pr}}
			</div>
        </div>
        {{#exclusive}}
         <div 
                        class="w-full lg:w-auto h-12 px-6 flex items-center justify-center gap-4 transition-all duration-300 hover:scale-95 bg-s-yellow"
                        aria-disabled="false">
                  <span class="text-xs tracking-widest font-semibold uppercase">In-Store Exclusive</span>
                </div>
        {{/exclusive}}
        
        {{^exclusive}}
        <button onClick="onAddToCartClick(event)" {{^isAvailable}}disabled{{/isAvailable}} {{#hidepresent}}disabled{{/hidepresent}} {{#isInCart}}disabled{{/isInCart}} id="swym-custom-add-toCartBtn" data-product-name="{{dt}}" data-state-cart="{{#isInCart}} swym-added{{/isInCart}}" data-product-url="{{du}}" data-initial-variant-id="{{epi}}" data-variant-id="{{epi}}" data-product-id="{{empi}}" data-quantity-price="{{pr}}" data-quantity-value="1" class="swym-custom-add-to-cart-button swym-add-to-cart-btn swym-is-button h-12 w-full uppercase text-xs font-semibold {{#hidepresent}} opacity-50 text-white {{/hidepresent}} {{^isAvailable}}bg-black opacity-50 text-white {{/isAvailable}} {{^hidepresent}} {{#isAvailable}} bg-s-yellow transition-opacity duration-300 hover:opacity-50{{/isAvailable}} {{/hidepresent}}" style="background-color: rgb(255 255 123 / var(--tw-bg-opacity)) !important;>
    <span class="text-xs tracking-widest font-semibold">
        {{^isAvailable}}Sold Out{{/isAvailable}}
        {{#isAvailable}}
            {{#hidepresent}}
                UnAvailable
            {{/hidepresent}}
            {{^hidepresent}}
                {{#isInCart}}
                    Added to Cart
                {{/isInCart}}
                {{^isInCart}}
                    Add to Cart 
                {{/isInCart}}
            {{/hidepresent}}
        {{/isAvailable}}
    </span>
</button>
        {{/exclusive}}
    </a>
	</div></li>
       {{/products}}
	</ul>`;

function stripTrailingZeros(val) {
  if (!val && val !== 0) return val;
  var s = String(val);
  if (s.indexOf('.') === -1) return s;
  s = s.replace(/0+$/, '');
  if (s.slice(-1) === '.') s = s.slice(0, -1);
  return s;
}

function getVariantInfo(variants) {
	try {
		let variantKeys = ((variants && variants != "[]") ? Object.keys(JSON.parse(variants)[0]) : []),
			variantinfo;
		if (variantKeys.length > 0) {
			variantinfo = variantKeys[0];
			if (variantinfo == "Default Title") {
				variantinfo = "";
			}
		} else {
			variantinfo = "";
		}
		return variantinfo;
	} catch (err) {
		return variants;
	}
}

// Add loader functionality
function showLoader() {
    const loader = document.querySelector('[data-swym-loader]');
    if (loader) loader.style.display = 'flex';
}

function hideLoader() {
    const loader = document.querySelector('[data-swym-loader]');
    if (loader) loader.style.display = 'none';
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', showLoader);
} else {
    showLoader();
}

function swymRenderWishlist(swat) {
    // Show loader while fetching data
    showLoader();

    var wishlistContentsContainer = document.getElementById("wishlist-items-container");
    swat.fetch(async (products) => {
        let product;
        console.log(products, "all products");
        let formattedWishlistedProducts = await Promise.all(products.map(async function (p) {
            const req = await fetch(`${p.du}.json`);
            const res = await req.json();
            var exclusive = false; 
            if (res) {
              product = res.product;
            }
            let tag = res.product.tags;
            console.log(tag,"Ank");
            if(tag.includes("inStoreExclusive")){
               var exclusive = true; 
            }
            else if (tag.includes("hide")) {
              console.log("String contains 'hide ' tag");
            var hidepresent1 = true;
            } else {
              console.log("String does not contain 'hide tag'");
              var  hidepresent1 = false;
            }
           
            let values = [];
            p = SwymUtils.formatProductPrice(p);
            p.pr = stripTrailingZeros(p.pr);
            p.isInCart = _swat.platform.isInDeviceCart(p.epi) || (p.et == _swat.EventTypes.addToCart);
            p.variantinfo = (p.vi ? getVariantInfo(p.vi) : "");
            let selectedVariant = product.variants.find((variant) => p.variantinfo == variant.title);
            selectedVariant = selectedVariant ? selectedVariant : product.variants[0];
            p.isAvailable = selectedVariant.inventory_quantity > 0;
            p.hidepresent = hidepresent1;
          if(p.isAvailable){
          p.exclusive =  exclusive;            
          }
          p.compare_at_price = selectedVariant.compare_at_price ? stripTrailingZeros(selectedVariant.compare_at_price) : false;
          console.log("yes",p.hidepresent);
            // Check if p.vi is defined before splitting
            let erpp = p.vi ? Number(p.vi.split("/")[0]) : 0;
            if (erpp > 0) {
                p.erpp = erpp;
            } else {
                p.erpp = Number(product.variants[0].title.split("/")[0]);
            }
            p.vendor = product.vendor;
            return p;

        }));

        console.log(formattedWishlistedProducts, "formattedWishlistedProducts");

        var productCardsMarkup = SwymUtils.renderTemplateString(productCardMarkup, {
            products: formattedWishlistedProducts
        });
        if (wishlistContentsContainer) {
            wishlistContentsContainer.innerHTML = productCardsMarkup;
            wishlistContentsContainer.style.display = '';
            attachClickListeners();
        } else {
            console.error("Container not found, Wishlist Page element not found");
        }

        // Hide loader after rendering
        hideLoader();
    });
}

function onAddToCartClick(e) {
	e.preventDefault();
	var btn = e.currentTarget;
	if (btn.disabled) return;

	var productId = btn.getAttribute("data-product-id");
	var variantId = btn.getAttribute("data-variant-id");
	var du = btn.getAttribute("data-product-url");

	btn.disabled = true;
	btn.style.opacity = '0.5';
	btn.style.cursor = 'not-allowed';
	btn.innerHTML = '<span class="text-xs tracking-widest font-semibold">Adding...</span>';

	window._swat.replayAddToCart({
		empi: productId,
		du: du
	}, variantId, function(c) {
		btn.innerHTML = '<span class="text-xs tracking-widest font-semibold">Added to Bag</span>';
		btn.setAttribute("data-state-cart", "swym-added");
		btn.disabled = true;
		btn.style.opacity = '0.5';
		btn.style.cursor = 'not-allowed';
		console.log("Successfully added product to cart.", c);
	}, function(err) {
		btn.disabled = false;
		btn.style.opacity = '';
		btn.style.cursor = '';
		btn.innerHTML = '<span class="text-xs tracking-widest font-semibold">Add to Cart</span>';
		customErrorHandling(err.description);
	});
}

function customErrorHandling(error) {
    _swat.ui.uiRef.showErrorNotification({ message: error });
  console.log(error,"error");
}
function customSuccessHandling(success) {
    _swat.ui.uiRef.showSuccessNotification({ message: success });
    console.log(success, "success");
}
function attachClickListeners() {
	var addToCartButtons = document.querySelectorAll("#swym-custom-add-toCartBtn");
	var removeBtns = document.querySelectorAll("#swym-remove-productBtn");
	//   Add to cart Btns
	for (var i = 0; i < addToCartButtons.length; i++) {
		addToCartButtons[i].addEventListener('click', onAddToCartClick, false);
	}
	//   Remove Buttons
	for (var k = 0; k < removeBtns.length; k++) {
		removeBtns[k].addEventListener('click', onRemoveBtnClick);
	}
	console.log("Events attached!");
}

function onRemoveBtnClick(e) {
	e.preventDefault();
	var epi = +e.currentTarget.getAttribute("data-variant-id");
	var empi = +e.currentTarget.getAttribute("data-product-id");
	window._swat.fetch(function(products) {
		products.forEach(function(product) {
			if (epi && empi && product.epi == epi && product.empi == empi) {
				window._swat.removeFromWishList(product, function() {
					if (!window.SwymCallbacks) {
						window.SwymCallbacks = [];
					}
					window.SwymCallbacks.push(swymRenderWishlist);
				});
			}
		});
	})
}

if (!window.SwymCallbacks) {
	window.SwymCallbacks = [];
}
window.SwymCallbacks.push(swymRenderWishlist); /* Init Here */
